import { atom } from 'jotai'
import { BusinessCustomerType, CustomerWallet, IndividualCustomerType } from 'types/customers'

export const currentCustomerAtom = atom<BusinessCustomerType | IndividualCustomerType>(
  {} as BusinessCustomerType | IndividualCustomerType
)
export const currentCustomerWalletAtom = atom<CustomerWallet>({} as CustomerWallet)
